import { render, staticRenderFns } from "./TaraAbsenteeismCard.vue?vue&type=template&id=2c7c9743&scoped=true"
import script from "./TaraAbsenteeismCard.vue?vue&type=script&lang=js"
export * from "./TaraAbsenteeismCard.vue?vue&type=script&lang=js"
import style0 from "./TaraAbsenteeismCard.vue?vue&type=style&index=0&id=2c7c9743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7c9743",
  null
  
)

export default component.exports